export default __webpack_public_path__ + "static/media/history.ac226c67.svg";